import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignatureOptionsSelector } from '../../options/selectors'
import { setSectionOneTypes, setSectionThreeTypes, setSectionTwoTypes } from '../../options/store/options.actions'
import { OptionsConstants } from '../../options/store/options.constants'
import { ISignatureOptionsState } from '../../options/store/options.types'
import { ISignatureTypeOption, ISignatureTypeOptions } from '../store/signatures.types'

export function* getSignatureTypes() {
  const signatureOptionsState: ISignatureOptionsState = yield select(getSignatureOptionsSelector)
  const { signatureTypeOptions } = signatureOptionsState

  const sectionOne: ISignatureTypeOptions = []
  const sectionTwo: ISignatureTypeOptions = []
  const sectionThree: ISignatureTypeOptions = []

  signatureTypeOptions.forEach((itemType: ISignatureTypeOption) => {
    if (itemType.name && itemType.name.includes('Section 1')) {
      itemType.name = itemType.name.split(' ').slice(3).join(' ')
      itemType.section = 1
      itemType.signatureType = itemType.name.split(' ')[0]
      sectionOne.push(itemType)
    } else if (itemType.name && itemType.name.includes('Section 2')) {
      itemType.name = itemType.name.split(' ').slice(3).join(' ')
      itemType.section = 2
      itemType.signatureType = itemType.name.split(' ')[0]
      sectionTwo.push(itemType)
    } else if (itemType.name && itemType.name.includes('Section 3')) {
      itemType.name = itemType.name.split(' ').slice(3).join(' ')
      itemType.section = 3
      itemType.signatureType = itemType.name.split(' ')[0]
      sectionThree.push(itemType)
    }
  })

  yield put(setSectionOneTypes(sectionOne))
  yield put(setSectionTwoTypes(sectionTwo))
  yield put(setSectionThreeTypes(sectionThree))
}
export function* setSectionsSignatureTypeButtonsSaga() {
  yield takeLatest([OptionsConstants.SET_SIGNATURE_TYPE_OPTIONS], getSignatureTypes)
}
